export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10987.89c1cbbb.jpg";